// extracted by mini-css-extract-plugin
export default {"image":"n1-z","loaded":"o1-z"};